import { Switch as SwitchPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib';

export type SwitchProps = ComponentProps<typeof SwitchPrimitive.Root>;

/** Тумблер (README «Поля форм → toggle»): 32×18, radius 9, бегунок 14; вкл — wine-bordeaux, выкл — line-strong. */
export function Switch({ className, ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        'relative h-18 w-32 shrink-0 cursor-pointer rounded-9 bg-line-strong transition-colors duration-(--duration-fast)',
        'data-[state=checked]:bg-wine-bordeaux disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb className="absolute top-2 left-2 block size-14 rounded-pill bg-paper-pure transition-[left] duration-(--duration-fast) data-[state=checked]:left-16" />
    </SwitchPrimitive.Root>
  );
}
